import { render, staticRenderFns } from "./Placa.vue?vue&type=template&id=669e569c&scoped=true&"
import script from "./Placa.vue?vue&type=script&lang=js&"
export * from "./Placa.vue?vue&type=script&lang=js&"
import style0 from "./Placa.vue?vue&type=style&index=0&id=669e569c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e569c",
  null
  
)

export default component.exports